import { combine, compute, dedupe } from '@exodus/atoms'

import filterAnnoucements from '../filter/index.js'

const createVisibleAnnouncementsAtom = ({ allAnnouncementsAtom, announcementsFiltersAtom }) => {
  const combinedAtom = combine({ allAnnouncementsAtom, announcementsFiltersAtom })

  const selector = (data) => {
    const { allAnnouncementsAtom: announcements, announcementsFiltersAtom: filters } = data

    return filterAnnoucements({ announcements, filters })
  }

  return dedupe(compute({ atom: combinedAtom, selector }))
}

export default createVisibleAnnouncementsAtom
